import { Component, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { Overlay } from '@angular/cdk/overlay';

import { AutocompleteTokensFieldComponent } from './autocomplete-tokens-field.component';
import { TokenItem } from './tokens-field.component';
import { WorkflowsService } from '../workflows/workflows.service';

@Component({
  selector: 'app-landing-pads-field',
  templateUrl: './autocomplete-tokens-field.component.html',
  styleUrls: ['./autocomplete-tokens-field.component.scss']
})
export class LandingPadsFieldComponent extends AutocompleteTokensFieldComponent {

  debounce: number = 400;
  subscription: Subscription;

  constructor(
    cd: ChangeDetectorRef,
    overlay: Overlay,
    private workflowsService: WorkflowsService) { super(cd, overlay); }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.subscription != null) {this.subscription.unsubscribe()}
  }

  loadSuggestions(value) {
    if (this.subscription != null) {this.subscription.unsubscribe()}
    if (value != null && value.trim() !== '') {
      this.subscription = this.workflowsService.getLandingPads(value, this.workflowId, 8).subscribe(
        (data: any) => {
          this.suggestions = data.landingPads.map((l) => {
            return {displayed: l.display_name, stored: l.system_id};
          })
          if (this.suggestions.length > 0) {
            this.selectedIndex = 0;
            this.showSuggestions();
          }
          this.loading = false;
          this.cd.markForCheck();
        },
        (errors) => {this.loading = false; this.cd.markForCheck();}
      )
    } else {
      this.loading = false;
      this.cd.markForCheck();
    }
  }

  commitValue() {
    if (this.subscription != null) {this.subscription.unsubscribe()}
    this.loading = false;
    this.cd.markForCheck();
    super.commitValue();
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/landing-pads-field.component.ts